import { Fragment } from 'react'
import { Input, Label } from 'reactstrap'
import { LI, P } from '../../../../../AbstractElements'
import { useTranslation } from 'react-i18next'

const VariationOfSwitchOne = ({ switchData }: { switchData: any[] }) => {
  const {t}=useTranslation()
  return (
    <>
      {switchData.map(({ id, inputClass, text, offData, onData }, index) => (
        <Fragment key={index}>
            <LI>
            <P>{t(text)}</P>
          </LI>
          <LI className="tg-list-item">
            <Input className={`tgl ${inputClass}`} id={id} type="checkbox" />
            <Label className="tgl-btn" data-tg-off={offData} data-tg-on={onData} htmlFor={id}></Label>
          </LI>
        
        </Fragment>
      ))}
    </>
  )
}

export default VariationOfSwitchOne